import { render, staticRenderFns } from "./IngredientSetting.vue?vue&type=template&id=9bcdd736&scoped=true&"
import script from "./IngredientSetting.vue?vue&type=script&lang=js&"
export * from "./IngredientSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcdd736",
  null
  
)

export default component.exports